import * as Sentry from '@sentry/react'

type SentryInitOptions = {
  dsn: string
  /**
   * App name for clear sorting
   */
  appName: string
}

export const initSentry = ({ appName, dsn }: SentryInitOptions) => {
  if (!dsn) return // don't init if DSN is missing (local dev without .env)

  const environment = import.meta.env.MODE ?? 'development'
  const release = import.meta.env?.VITE_RELEASE_VERSION ?? 'development'

  Sentry.init({
    dsn,
    environment,
    release,

    /**
     * Enables browser vitals tracking (LCP, INP) and activates distributed tracing capabilities
     */
    integrations: [Sentry.browserTracingIntegration()],

    /**
     * PERFORMANCE TRACING QUOTA
     * Captures 1% of transactions in production to monitor load times and API latency
     * Kept at 0% (disabled) locally to prevent Sentry telemetry from polluting the local dev network tab
     */
    tracesSampleRate: environment === 'production' ? 0.01 : 0,
  })

  /**
   * Stamped on every single issue sent from this initialization
   * Important for cross-project dashboards or if multiple apps share a staging environment
   */
  Sentry.setTag('nx_project', appName)
}
